module.exports = __webpack_public_path__ + "img/x9.f4255c93.jpg";